module.exports = __webpack_public_path__ + "img/polygon.2d602bb9.svg";